export default __webpack_public_path__ + "static/media/homepage-online-platform.de01375e.jpg";